import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ConfirmButton } from "@/components/ConfirmButton";
import { useOperators } from "@/components/mobile/operators";
import { simCount, simOperators } from "@/components/sim/DealerSimCounts";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";

export const SimQuickMove = ({ dealer, meId, onClose, onDone }) => {
  const ops = simOperators(useOperators());
  const [pick, setPick] = useState("");
  const op = ops.find((o) => o.key === pick) || (ops.length === 1 ? ops[0] : null);
  const [dir, setDir] = useState("give");
  const [qty, setQty] = useState(10);
  const [busy, setBusy] = useState(false);
  const n = Number(qty);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/sim-stock/move", { ...(dir === "give" ? { from_id: meId, to_id: dealer.id } : { from_id: dealer.id, to_id: meId }), qty: n, note: "", operator: op.key });
      toast.success(dir === "give" ? `${n} SIM ${op.name} assegnate a ${dealer.name}` : `${n} SIM ${op.name} riprese da ${dealer.name}`);
      window.dispatchEvent(new Event("sim-changed")); onDone?.(); onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Spostamento non riuscito"); }
    finally { setBusy(false); }
  };
  return <Dialog open={!!dealer} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="sim-quick-move-dialog">
      <DialogHeader><DialogTitle>Sposta SIM · {dealer?.name}</DialogTitle></DialogHeader>
      <div className="space-y-2" data-testid="sim-quick-operators">
        <p className="text-sm font-medium">Per quale operatore?</p>
        <div className="flex flex-wrap gap-2">{ops.map((o) => <Button key={o.key} size="sm" variant={op?.key === o.key ? "default" : "outline"} onClick={() => setPick(o.key)} data-testid={`sim-quick-op-${o.key}`}>{o.name} · {simCount(dealer, o.key)} SIM</Button>)}</div>
      </div>
      {op && <>
        <p className="text-sm text-muted-foreground" data-testid="sim-quick-stock">Il dealer ha {simCount(dealer, op.key)} SIM {op.name}.</p>
        <div className="grid grid-cols-2 gap-2">
          <Button variant={dir === "give" ? "default" : "outline"} className="gap-2" onClick={() => setDir("give")} data-testid="sim-quick-give"><ArrowUpRight className="w-4 h-4" />Dai SIM al dealer</Button>
          <Button variant={dir === "take" ? "default" : "outline"} className="gap-2" onClick={() => setDir("take")} data-testid="sim-quick-take"><ArrowDownLeft className="w-4 h-4" />Riprendi SIM</Button>
        </div>
        <Input type="number" min="1" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="sim-quick-qty" />
        <ConfirmButton disabled={busy || !(n >= 1)} onConfirm={submit} data-testid="sim-quick-submit" confirmTestId="sim-quick-confirm" title="Confermi lo spostamento?"
          description={dir === "give" ? `Stai dando ${n} SIM ${op.name} a ${dealer?.name}: escono dalle tue SIM.` : `Stai riprendendo ${n} SIM ${op.name} da ${dealer?.name}: tornano alle tue SIM.`} confirmText="Conferma">
          {busy ? "Spostamento…" : `Sposta ${qty} SIM ${op.name}`}
        </ConfirmButton>
      </>}
    </DialogContent>
  </Dialog>;
};
